/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, arrayOf, shape, string, bool,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import MobileOrderListItem from './MobileOrderListItem';
import { deepObjectExtend } from '../../utils/object';
import { combineStyle } from '../../style/combineStyle';
import { main as MainStyle } from '../../style/main';
import { MobileOrderListStyle } from '../../style/MobileOrderListStyle';

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        MobileOrderListStyle,
    }),
);

class MobileOrderList extends PureComponent {
    render() {
        const {
            classes,
            order: {
                orderNumber, items, uuid,
            },
            userProfile,
            brand,
        } = this.props;

        let { order: { orderPlaceddate: orderDate } } = this.props;
        if (!orderDate) {
            [{ orderDate }] = items;
        }
        const hasOrderSpecific = orderNumber?.includes('3410286682');
        return (
            <div className={classes.MobileOrderListStyle}>
                <Grid container>
                    <Grid item xs={12}>
                        {
                            items.map((data, i) => (
                                <MobileOrderListItem key={['_', i].join('')} classes={classes} orderNumber={orderNumber} index={i} uuid={uuid} items={data} hasOrderSpecific={hasOrderSpecific} userProfile={userProfile} brand={brand} />
                            ))
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }
}

MobileOrderList.propTypes = {
    classes: object.isRequired,
    order: shape({
        orderNumber: string,
        intOrderNumber: string,
        orderPlaceddate: string,
        customerFirstName: string,
        customerLastName: string,
        modifyOrder: string,
        parentOrderNumber: string,
        uuid: string,
        items: arrayOf(
            shape({
                brandId: string,
                productSku: string,
                productName: string,
                recpFirstName: string,
                recpLastName: string,
                shipDate: string,
                paymentStatus: string,
                estimatedDeliveryDate: string,
                trackingNumber: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                flexDate: string,
                flexMessage: string,
                flexGuaranteedFlag: string,
                prdImgCtg: string,
                prdImgTmn: string,
                arrivalStartDate: string,
                arrivalEndDate: string,
                carrier: string,
                seoUrl: string,
                subscriptionType: string,
                interval: string,
                duration: string,
            }),
        ),
    }).isRequired,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    brand: object.isRequired,
};

export default withStyles(styles)(MobileOrderList);
